import { useBunker } from '@/providers/BunkerProvider';
import { useLingui } from '@lingui/react';
import { Box, Image, Paper, Tooltip, rem } from '@mantine/core';
import { IconCircleCheckFilled, IconLockFilled } from '@tabler/icons-react';
import classes from './Bunker.module.css';
import type { BunkerInventoryItemType } from './data';
export type BunkerInventoryItemProps = BunkerInventoryItemType & {
  handleClick: () => void;
};
export const BunkerInventoryItem: React.FC<BunkerInventoryItemProps> = ({
  id,
  imgUrl,
  isLocked,
  handleClick
}) => {
  const {
    active
  } = useBunker();
  const {
    i18n
  } = useLingui();
  return <Tooltip classNames={{
    tooltip: classes.tooltip
  }} position="top" withArrow arrowSize={10} label={isLocked ? i18n._('Locked') : i18n._('Ghost Special')}>
      <Paper w={{
      base: 120,
      lg: 147
    }} h={{
      base: 120,
      lg: 147
    }} bd="1px solid #586572" radius={5} pos="relative" className={isLocked ? classes.itemLocked : classes.item} mod={{
      active: id === active.id
    }} onClick={handleClick}>
        <Image src={imgUrl} mx="auto" w={{
        base: 94,
        lg: 110
      }} mt={-15} />

        <Box pos="absolute" bottom={0} right={rem(5)}>
          {isLocked ? <IconLockFilled /> : id === active.id ? <IconCircleCheckFilled /> : null}
        </Box>
      </Paper>
    </Tooltip>;
};